import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { apis } from "../../api/apiUrl"


// Create an async thunk
export const fetchScholarshipsData = createAsyncThunk(
    "fetchScholarshipsData",
    async (data) => {
        const { closedate, searchText } = data
        let url = `${apis.uniten_api}/GetScholarship`

        const response = await fetch(url, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                closeDate: closedate,
                search: searchText
            })
        })
        return await response.json()

    }
)

// Create a slice
const scholarshipsSlice = createSlice({
    name: "scholarships",
    initialState: {
        isLoading: false,
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(fetchScholarshipsData.pending, (state) => {
            state.isLoading = true
        })
        builder.addCase(fetchScholarshipsData.fulfilled, (state, action) => {
            state.isLoading = false
            state.data = action.payload
        })
        builder.addCase(fetchScholarshipsData.rejected, (state, action) => {
            console.log("Error", action)
            state.isLoading = false
        })
    }
})

export default scholarshipsSlice.reducer